import React from 'react';
import { motion } from 'framer-motion';
export function AudienceSection() {
  return <section className="w-full px-6 py-20 md:py-28 bg-cream-50" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24" data-id="element-13">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-14">
            <h3 className="font-serif text-2xl text-stone-800 mb-6 pb-2 border-b border-terracotta/20" data-id="element-15">
              Who this is for
            </h3>
            <ul className="space-y-4 text-stone-600 text-lg leading-relaxed" data-id="element-16">
              <li data-id="element-17">
                Women 30 plus who feel like their body changed and they need a
                plan that respects reality.
              </li>
              <li data-id="element-18">Women who want structure, not drama.</li>
              <li data-id="element-19">Women who want to stop negotiating with chaos.</li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-20">
            <h3 className="font-serif text-2xl text-stone-800 mb-6 pb-2 border-b border-stone-200" data-id="element-21">
              Who this is not for
            </h3>
            <ul className="space-y-4 text-stone-600 text-lg leading-relaxed" data-id="element-22">
              <li data-id="element-23">Anyone looking for extreme dieting.</li>
              <li data-id="element-24">Anyone who wants medical treatment advice.</li>
              <li data-id="element-25">Anyone in active eating disorder recovery.</li>
              <li data-id="element-26">Anyone who needs a clinician for unexplained symptoms.</li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}